<form [formGroup]="form" (ngSubmit)="save()">
  <h1 mat-dialog-title>Cambio de equipo</h1>
  <div mat-dialog-content>
    <mat-spinner *ngIf="loading"></mat-spinner>
    <h3 *ngIf="!existsEquipments && !loading">No es posible reemplazar al equipo</h3>
    <mat-form-field *ngIf="!loading && existsEquipments" class="full-width">
      <input type="text" #physician matInput placeholder="Equipo" required formControlName="Equipment" [matAutocomplete]="autPhysician">
      <mat-autocomplete #autPhysician="matAutocomplete" [displayWith]="filterCompleteEquipments.displayFn">
        <mat-option *ngFor="let equipment of filteredEquipmentsOptions | async" [value]="equipment">
          {{equipment.Name}}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="f.Equipment.errors && f.Equipment.errors.validAutoCompleteSelect">
        Ingrese el médico
      </mat-error>
    </mat-form-field>
  </div>
  <div class="clearfix">
    <div *ngIf="!loading" class="pull-right">
      <button *ngIf="existsEquipments" mat-button type="submit">Guardar</button>
      <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
    </div>
  </div>
</form>


